import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type CostIndicatorsFetchFailedAction = {
	type: 'COST_INDICATORS_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): CostIndicatorsFetchFailedAction => ({
	type: 'COST_INDICATORS_FETCH_FAILED',
	payload,
});
